import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import Header from "../components/Header";
import Footer from '../components/Footer'

const Links = () => (
    <div>
        <Header/>
        <div className="content partslist-page">
            <div className="container">
                <div className="pb-5">
                    <h1 className="title-partslist-page">リンク</h1>
                    <div className="img-three-dot">
                        <img src="images/three-dot.png" className="img-fluid"/>
                    </div>
                    <ul>
                        <li><a href="http://www.meat-kimura.co.jp/" target="_blank">株式会社ミートキムラ</a></li>
                        <li><a href="http://kenko.morinagamilk.co.jp/index.html" target="_blank">森永乳業健康食品部</a></li>
                        <li><a href="http://www.aminovital.com/" target="_blank">アミノバイタル</a></li>
                        <li><a href="http://corisco.jp/" target="_blank">株式会社コアリボンスクエア</a></li>
                        <li><a href="http://www.ajinomoto.co.jp/" target="_blank">株式会社味の素</a></li>
                        <li><a href="http://www.j-road66.co.jp/" target="_blank">株式会社ジェイロード</a></li>
                        <li><a href="http://www.kentai.co.jp/" target="_blank">健康体力研究所　KENTAI</a></li>
                        <li><a href="http://www.ggmania.jp/" target="_blank">GOLD'S GYM</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
)

export default Links